import React from 'react';

import { Container, Row, Col, Card, Button } from 'reactstrap';
import { AccountSecurityIcon } from '../elements/icons/Icons';
import CardFooter from 'reactstrap/es/CardFooter';

const AccountSecurity = ({
    dto,
    displayBody,
    onPasswordChange,
    onChangePasswordClick,
    onPasswordSubmit,
    onResetPasswordClick,
}) => {
    return (
        <Card className={'account-security-wrapper'}>
            <CardFooter className="d-flex justify-content-between"></CardFooter>
            {displayBody && (
                <Container className="my-3" fluid>
                    <Row>
                        <Col xs={12} md={4}>
                            <div className="form-group">
                                <label>Current Password</label>
                                <input
                                    type="password"
                                    name="currentPassword"
                                    className="form-control"
                                    placeholder="Current Password"
                                    value={dto.currentPassword}
                                    onChange={onPasswordChange}
                                />
                            </div>
                        </Col>
                        <Col xs={12} md={4}>
                            <div className="form-group">
                                <label>New Password</label>
                                <input
                                    type="password"
                                    name="newPassword"
                                    className="form-control"
                                    placeholder="New Password"
                                    value={dto.newPassword}
                                    onChange={onPasswordChange}
                                />
                            </div>
                        </Col>
                        <Col xs={12} md={4}>
                            <div className="form-group">
                                <label>Confirm Password</label>
                                <input
                                    type="password"
                                    name="confirmPassword"
                                    className="form-control"
                                    placeholder="Confirm Password"
                                    value={dto.confirmPassword}
                                    onChange={onPasswordChange}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} className="text-right">
                            <a href="#" onClick={onResetPasswordClick}>
                                Forgot password?
                            </a>
                        </Col>
                    </Row>

                    {dto.error && (
                        <Row>
                            <Col xs={12} md={12} className="text-right">
                                <p>{dto.error}</p>
                            </Col>
                        </Row>
                    )}
                </Container>
            )}
        </Card>
    );
};

export default AccountSecurity;
